import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_uymja4qx4h: FaireBrandEntity = {
  token: "b_uymja4qx4h",
  type: "brand",
  name: "Shuug",
  avatarUrl:
    "https://cdn.faire.com/fastly/ae80e811866e90405788cd7614c13d24bff61fae4baea96f806618c5d20f16a5.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/52858b490ded9d0554f460943f1d8f1d8f4fa940fb33166343b62b089a5b28ab.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ae80e811866e90405788cd7614c13d24bff61fae4baea96f806618c5d20f16a5.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/52858b490ded9d0554f460943f1d8f1d8f4fa940fb33166343b62b089a5b28ab.jpeg",
  location: "598 Hayden station rd, CT, USA",
  minimumOrderDollars: 40,
  rating: 5,
  reviewCount: 41,
  isTopShop: true,
  isInsider: true,
  description:
    "At Shuug, we're proud to introduce a handcrafted line of hot sauces that bring the bold, vibrant flavors of the Middle Eastern and Mediterranean regions to life—rooted in decades-old family recipes. Our mission is simple: to bring back the nostalgic feeling of friends and family gathered around the table. Whether you're on the road or far from home, Shuug offers a taste of comfort, familiarity, and connection.\n\nOur first SKU is Zhoug, a herby, peppery hot sauce we like to call the Middle Eastern Sriracha. Made with a fiery blend of scotch bonnets, poblanos, and jalapeños, balanced with fresh herbs and warm spices, it's where savory meets spice in the best way.\n\nOur second SKU is Harissa, a rich, smoky red chili sauce that delivers bold heat and earthy depth. Crafted with roasted red peppers, chilies, and fragrant spices, it’s our take on a North African staple reimagined for today’s kitchen.\n\nOur third SKU is Amba, a bright, tangy green mango sauce that delivers bold flavor with a subtle kick. Made with green mango, turmeric, and warm spices, it’s our take on a Middle Eastern staple reimagined for today’s kitchen.\n\nOur products are also gluten-free, non-GMO, and crafted with clean, vegan, and kosher-certified ingredients, so you can enjoy a spicy kick without any guilt.",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:18:08.979Z",
    importedBy: "entity-db-cli",
  },
};
